/* mt-perf-volet.js — Volet de personnalisation MyTomette (panier : aperçu + « Modifier » ; fiche : « Personnaliser » ;
   écoute des messages du configurateur, dont « mtcfg-added » → panier, utilisé aussi par la surcouche mt-config-overlay).
   Sorti de layout/theme.liquid le 23/09/2026 (≈ 11 Ko retirés de chaque page), chargé en defer au même endroit.
   Code identique ; les valeurs Liquid (URL du configurateur, libellés, gabarit) arrivent par window.__mtVolet. */
(function(){
  "use strict";
  var C = window.__mtVolet || {}, T = C.t || {};
  function escH(s){ return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
  /* CSS du volet (ex-<style> de layout/theme.liquid), posé au même endroit du document qu'avant : juste avant ce script. */
  (function(){
    var st = document.createElement('style'), me = document.currentScript;
    st.textContent = ".mt-volet-overlay{position:fixed;inset:0;z-index:9998;background:rgba(44,24,16,.45);opacity:0;visibility:hidden;transition:opacity .3s ease,visibility .3s ease;-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);}\n.mt-volet-overlay.mt-open{opacity:1;visibility:visible;}\n.mt-volet{position:fixed;top:0;right:0;height:100%;width:min(620px,94vw);z-index:9999;background:var(--mt-cream,#FAF7F2);box-shadow:var(--mt-shadow-xl,0 24px 64px rgba(44,24,16,.18));transform:translateX(100%);transition:transform .34s cubic-bezier(.22,.61,.36,1);display:flex;flex-direction:column;}\n.mt-volet.mt-open{transform:translateX(0);}\n.mt-volet-head{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:13px 18px;border-bottom:1px solid rgba(44,24,16,.08);flex:0 0 auto;}\n.mt-volet-title{font-family:var(--mt-font-display,'Cormorant Garamond',serif);font-size:1.3rem;font-weight:600;color:var(--mt-brown,#2C1810);margin:0;}\n.mt-volet-close{width:40px;height:40px;border:none;border-radius:50%;background:transparent;color:var(--mt-brown,#2C1810);font-size:24px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background .2s ease;}\n.mt-volet-close:hover{background:var(--mt-sand-light,#F3EBE2);}\n.mt-volet-body{flex:1 1 auto;position:relative;background:var(--mt-cream,#FAF7F2);}\n.mt-volet-iframe{position:absolute;inset:0;width:100%;height:100%;border:0;display:block;}\n.mt-volet-msg{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;text-align:center;padding:30px;color:var(--mt-terra-dark,#A8532E);font-family:var(--mt-font-body,'DM Sans',sans-serif);}\n@media (max-width:768px){\n.mt-volet{width:100%;height:100dvh;transform:none;visibility:hidden;opacity:0;transition:opacity .25s ease,visibility .25s ease;}\n.mt-volet.mt-open{transform:none;visibility:visible;opacity:1;}\n.mt-volet-overlay{background:var(--mt-cream,#FAF7F2);-webkit-backdrop-filter:none;backdrop-filter:none;}\n.mt-volet-head{display:none;}\n}\n.mt-edit-btn,.mt-perso-btn{display:inline-flex;align-items:center;justify-content:center;gap:7px;font-family:var(--mt-font-body,'DM Sans',sans-serif);font-weight:600;cursor:pointer;border-radius:var(--mt-radius-sm,6px);transition:all .2s ease;text-decoration:none;line-height:1.2;}\n.mt-edit-btn{margin-top:10px;font-size:.82rem;padding:7px 14px;color:var(--mt-terra-dark,#A8532E);background:transparent;border:1px solid var(--mt-terra,#C1643C);}\n.mt-edit-btn:hover{background:var(--mt-terra,#C1643C);color:#fff;}\n.mt-perso-btn{width:100%;font-size:.95rem;padding:14px 20px;margin-top:10px;color:#fff;background:var(--mt-terra,#C1643C);border:none;}\n.mt-perso-btn:hover{background:var(--mt-terra-dark,#A8532E);}\n.mt-cart-thumb img{object-fit:contain!important;background:var(--mt-cream-warm,#F5EFE6);}";
    if (me && me.parentNode) me.parentNode.insertBefore(st, me); else document.head.appendChild(st);
  })();
  var APP_URL = window.MT_CONFIG_I18N.url(C.app);
  var TOMETTE_PRODUCT_IDS = ['15483183989076']; // ← ajoute d'autres ID produit tomette au besoin

  // ---- Le volet (configurateur chargé en srcdoc) ----
  var overlay, panel, iframe, titleEl, body;
  var cachedHtml = null, htmlPromise = null;
  var pendingPayload = null, payloadSent = false, currentEditKey = null, generation = 0;

  function ensureHtml(){
    if (cachedHtml) return Promise.resolve(cachedHtml);
    if (htmlPromise) return htmlPromise;
    htmlPromise = fetch(APP_URL, { credentials:'same-origin' })
      .then(function(r){ return r.text(); })
      .then(function(html){ cachedHtml = html; return html; });
    return htmlPromise;
  }
  function buildVolet(){
    if (overlay) return;
    overlay = document.createElement('div'); overlay.className = 'mt-volet-overlay';
    panel = document.createElement('div'); panel.className = 'mt-volet';
    panel.innerHTML =
      '<div class="mt-volet-head"><p class="mt-volet-title">' + escH(T.titre) + '</p>' +
      '<button class="mt-volet-close" type="button" aria-label="' + escH(T.fermer) + '">&times;</button></div>' +
      '<div class="mt-volet-body"><div class="mt-volet-msg">' + escH(T.charge) + '</div></div>';
    document.body.appendChild(overlay); document.body.appendChild(panel);
    body = panel.querySelector('.mt-volet-body');
    titleEl = panel.querySelector('.mt-volet-title');
    overlay.addEventListener('click', requestCloseVolet);
    panel.querySelector('.mt-volet-close').addEventListener('click', requestCloseVolet);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') requestCloseVolet(); });
  }
  function openVolet(opts){
    opts = opts || {}; buildVolet();
    if(panel.classList.contains('mt-open'))return;
    var opening=++generation;
    currentEditKey = opts.editKey || null;
    titleEl.textContent = opts.title || 'Personnaliser ma tomette';
    payloadSent = false;
    pendingPayload = opts.recipe
      ? { type:'mtcfg-load', recipe: opts.recipe, edit:true, drawer:true, editKey: opts.editKey || null }
      : { type:'mtcfg-config', drawer:true, editKey:null };
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function(){ overlay.classList.add('mt-open'); panel.classList.add('mt-open'); });
    ensureHtml().then(function(html){
      if(opening!==generation)return;
      body.innerHTML = '<iframe class="mt-volet-iframe" title="Configurateur de tomette" allow="fullscreen"></iframe>';
      iframe = body.querySelector('.mt-volet-iframe');
      // Blob URL plutôt que srcdoc : l'iframe devient un vrai document qui RESPECTE la
      // balise viewport. (Sur Android, srcdoc l'ignore -> configurateur rendu trop large
      // et coupé à droite.) Le Blob contourne aussi le blocage d'iframe, comme srcdoc.
      var blob = new Blob([html], { type:'text/html' });
      var url = URL.createObjectURL(blob);
      iframe.addEventListener('load', function(){
        setTimeout(function(){ try { URL.revokeObjectURL(url); } catch(e){} }, 5000);
      }, { once:true });
      iframe.src = url;
    }).catch(function(){
      if(opening!==generation)return;
      body.innerHTML = '<div class="mt-volet-msg">Impossible de charger le configurateur. Réessayez.</div>';
    });
  }
  function requestCloseVolet(){
    if(!panel||!panel.classList.contains('mt-open'))return;
    if(!iframe){closeVolet(true);return;}
    try{if(typeof iframe.contentWindow._mtAskClose==='function'){iframe.contentWindow._mtAskClose();if(iframe)iframe.__mtCloseAskedAt=0;return;}}catch(e){}
    var now=Date.now();
    if(iframe.__mtCloseAskedAt && now-iframe.__mtCloseAskedAt>=2000){
      iframe.__mtCloseAskedAt=0;
      if(window.confirm(/^en\b/i.test((window.MT_CONFIG_I18N||{}).locale||document.documentElement.lang||'') ? 'The editor is not responding. Leave without saving? Your design may be lost.' : 'L’éditeur ne répond pas. Quitter sans enregistrer ? Votre création risque d’être perdue.')) closeVolet(true);
      return;
    }
    if(!iframe.__mtCloseAskedAt)iframe.__mtCloseAskedAt=now;
    try{iframe.contentWindow.postMessage({mtcfg:'requestClose'},'*');}catch(e){}
  }
  function closeVolet(approved){
    if(iframe&&approved!==true){requestCloseVolet();return;}
    if (!panel) return;
    var closing=++generation;
    overlay.classList.remove('mt-open'); panel.classList.remove('mt-open');
    document.body.style.overflow = '';
    pendingPayload = null;
    setTimeout(function(){ if(closing!==generation)return; if (body) body.innerHTML = ''; iframe = null; }, 360);
  }
  function sendPayload(){
    if (payloadSent || !pendingPayload || !iframe || !iframe.contentWindow) return;
    payloadSent = true;
    try { iframe.contentWindow.postMessage(pendingPayload, '*'); } catch(e){}
  }

  // ---- Messages du configurateur ----
  window.addEventListener('message', function(ev){
    var d = ev && ev.data;
    var ownFrame=iframe&&ev.source===iframe.contentWindow&&panel&&panel.classList.contains('mt-open');
    if(!ownFrame)return;
    if (d === 'mtcfg-ready'){ if(ownFrame)sendPayload(); return; }
    if (d === 'mtcfg-close'||(d&&d.mtcfg==='close')){ if(ownFrame)closeVolet(true); return; }
    if (ownFrame&&d&&d.mtcfg==='nav'&&typeof d.url==='string'){window.location.href=d.url;return;}
    if (d && typeof d === 'object' && d.type === 'mtcfg-added'){
      var key = d.editKey || currentEditKey;
      if (key){
        fetch(window.MT_CONFIG_I18N.url('/cart/change.js'), { method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ id: key, quantity: 0 }) })
          .then(function(){ window.location.href = window.MT_CONFIG_I18N.url('/cart'); })
          .catch(function(){ window.location.href = window.MT_CONFIG_I18N.url('/cart'); });
      } else {
        window.location.href = window.MT_CONFIG_I18N.url('/cart');
      }
    }
  });

  // ---- PANIER : aperçu de la tomette + bouton « Modifier » ----
  var cartBusy = false;
  function enhanceCart(){
    var rows = document.querySelectorAll('tr.cart-items__table-row[data-key]:not([data-mt-done])');
    if (!rows.length || cartBusy) return;
    cartBusy = true;
    fetch(window.MT_CONFIG_I18N.url('/cart.js'), { headers:{ 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var byKey = {}; (cart.items || []).forEach(function(it){ byKey[it.key] = it; });
        rows.forEach(function(row){
          var key = row.getAttribute('data-key'); var it = byKey[key];
          if (!it || !it.properties || !it.properties._recette) return;
          row.setAttribute('data-mt-done','1');
          var props = it.properties;
          var apercu = null;
          for (var k in props){
            if (k === '_recette') continue;
            var v = props[k];
            if (typeof v === 'string' && /\.png(\?|$)/i.test(v)) { apercu = v; break; }
          }
          if (apercu){
            var media = row.querySelector('.cart-items__media');
            if (media){
              media.classList.add('mt-cart-thumb');
              var img = media.querySelector('img');
              if (img){ img.removeAttribute('srcset'); img.src = apercu; }
              else {
                var box = media.querySelector('.cart-items__media-container') || media;
                var ni = document.createElement('img'); ni.src = apercu; ni.alt = T.alt;
                ni.style.width = '100%'; ni.style.height = 'auto'; box.appendChild(ni);
              }
            }
          }
          var details = row.querySelector('.cart-items__details') || row;
          var recipeObj = null; try { recipeObj = JSON.parse(props._recette); } catch(e){}
          var btn = document.createElement('button');
          btn.type = 'button'; btn.className = 'mt-edit-btn'; btn.innerHTML = '✎ Modifier';
          btn.addEventListener('click', function(){
            openVolet({ recipe: recipeObj, editKey: key, title: T.modif });
          });
          details.appendChild(btn);
        });
        cartBusy = false;
      })
      .catch(function(){ cartBusy = false; });
  }

  // ---- FICHE PRODUIT : bouton « Personnaliser » ----
  function enhanceProduct(){
    var pf = document.querySelector('product-form-component[data-product-id]');
    if (!pf || pf.getAttribute('data-mt-done')) return;
    var pid = String(pf.getAttribute('data-product-id') || '');
    if (TOMETTE_PRODUCT_IDS.indexOf(pid) === -1) return;
    pf.setAttribute('data-mt-done','1');
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'mt-perso-btn';
    btn.textContent = T.perso;
    btn.addEventListener('click', function(){ openVolet({ title:'Personnaliser ma tomette' }); });
    var buttons = pf.querySelector('.product-form-buttons') || pf;
    buttons.appendChild(btn);
  }

  function run(){ try { enhanceCart(); } catch(e){} try { enhanceProduct(); } catch(e){} }
  var MT_TPL = C.tpl;
  if (MT_TPL !== 'cart' && MT_TPL !== 'product') return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  var deb;
  var mo = new MutationObserver(function(){ clearTimeout(deb); deb = setTimeout(run, 200); });
  var mtScope = document.querySelector('main') || document.body;
  try { mo.observe(mtScope, { childList:true, subtree:true }); } catch(e){}
})();
